import { IUserState } from ".";
import * as actions from './actions'
import * as actionsAuth from '../authentication/actions'

const initialState: IUserState = {
    id: '',
    name: '',
    email: '',
    isPendingEmail: false,
    subscriptions: []
}
export const userReducer = (state: IUserState = initialState, action) => {
    switch (action.type) {
        case actions.LOAD_USER_INFO_SUCCESS:
            return { ...action.payload }
        case actions.USER_INFO_LOADING:
        case actions.LOAD_USER_INFO_FAIL:
        case actionsAuth.LOGIN_START:
        case actionsAuth.SIGN_UP_START:
        case actionsAuth.AUTHENTICATION_FAIL:
        case actionsAuth.LOGOUT:
            return initialState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/user/reducer.ts